const statusText = ['Draft', 'Submitted', 'Processing', 'Paid', 'Cancelled'];

export {
    statusText
};
